export default __webpack_public_path__ + "static/media/humidity.ecc78abe.png";